import * as React from 'react';
import { useState } from "react";

import Dialog from '@mui/material/Dialog';

import DialogContent from '@mui/material/DialogContent';

import DialogTitle from '@mui/material/DialogTitle';
import StatusContext from '../../../contexts/StatusContext'
import AuthContext from "../../../contexts/AuthContext";

import { PushButton } from '../pushbutton/PushButton';


import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { ProgressIcon } from '../customicons/ProgressIcon';
import TextField from '@mui/material/TextField';
import axios from 'axios'
import { config } from "../../../config";

export const  DialogNewPassword = () => {

 
  const[loginstatus, setLoginStatus] = useState('')
   
  
    const {
        changeLanguage,
        isLoading,
        setIsLoading,
        shownewpassworddialog,
        setShowNewPasswordDialog,
        logininputs,
        setLoginInputs,
     
    } = React.useContext(StatusContext);

    let {
     
      saveCurrentUser,
    
    } = React.useContext(AuthContext);

   
    const handleChange = (e) => {
    
       setLoginInputs((prev)=>({...prev,[e.target.name]: e.target.value }))
       setLoginStatus('')
   }

  const handleClose = () => {
    setShowNewPasswordDialog(false);
  };

  const onClickNewPassword = async (e) => {
    e.preventDefault()
    console.log("New test")

    if (logininputs.newpassword.length < 8)
    {
      setLoginStatus(changeLanguage('status', 'passwordlength'))
      return;
    }

    if (logininputs.newpassword !== logininputs.confirmnewpassword)
    {
      setLoginStatus(changeLanguage('status', 'passwordmismatch'))
      return;
    }

    setLoginStatus('')
    let userid = ({
      username:logininputs.username,
      password:logininputs.newpassword,
    })


    //save new password
    setIsLoading(true)
    try {
      await axios.post(config.url.API_URL + "/deda_ai_api/auth/newpassword", userid)
      saveCurrentUser(logininputs.username)
    
    } catch (err) {
        console.log("Newpassword err:", err.response.data)
        setLoginStatus(err.response.data)
        setIsLoading(false)
        return;
    }

    setIsLoading(false)
    
    setShowNewPasswordDialog(false)
 
}

  return (
    <React.Fragment>
        <Dialog
     
          open={shownewpassworddialog}
          onClose={handleClose}
          PaperProps={{
            component: 'form',
            onSubmit: (event) => {
              event.preventDefault();
              const formData = new FormData(event.currentTarget);
              const formJson = Object.fromEntries(formData.entries());
              const email = formJson.email;
              console.log(email);
              handleClose();
            },
          }}
        >

      <ProgressIcon isLoading={isLoading} /> 
     
      <DialogTitle>Login</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
       <CloseIcon />
      </IconButton>
      <DialogContent>
   
      <div className='loginNewPasswordTitle'>{changeLanguage('login', 'newpassword')}</div>
                        
        <br></br>
        <TextField
          autoFocus
          required
          margin="dense"
                        
          name="newpassword"
          label={changeLanguage('signup','placeholderpassword')}
          type="password"
          fullWidth
          variant="standard"
          onChange = {handleChange}
          value = {logininputs.newpassword}
        />
        <br></br>
          <TextField      
            required
            margin="dense"
                        
            name="confirmnewpassword"
            label={changeLanguage('signup','placeholderconfirmpassword')}
            type="password"
            fullWidth
            variant="standard"
            onChange = {handleChange}
            value = {logininputs.confirmnewpassword}
          />
          <br></br>
          <br></br>
          <PushButton label={changeLanguage('login','submit')} onClick={onClickNewPassword}/>
          <br></br>  
          {
            (loginstatus) && <div className='loginStatus'><label>{loginstatus}</label></div>
          }           
         
      </DialogContent>
      </Dialog>
     

    </React.Fragment>
    
  );
}